import { IShapeOptions } from "./BaseShape";
import { Line } from "./Line";
import { Vector } from "../Core/Vector";

export type BentLineOptions = IShapeOptions & {
    isHorizontal?: boolean;
    isCurved?: boolean;
};

export class BentLine extends Line {

    private isHorizontal: boolean;
    private isCurved: boolean;

    // 重构构造函数
    constructor(x1: number, y1: number, x2: number, y2: number, options?: BentLineOptions)
    constructor(start: Vector, end: Vector, options?: BentLineOptions)
    constructor(a: any, b: any, c?: any, d?: any, e?: any) {
        // 调用父类构造函数，它会处理坐标和 options，并调用 calcSize
        super(a, b, c, d, e);

        let opts: BentLineOptions | undefined;

        if (a instanceof Vector && b instanceof Vector) {
            // 第二种调用方式，c 是 options
            opts = c as BentLineOptions;
        } else {
            // 第一种调用方式，e 是 options
            opts = e as BentLineOptions;
        }

        const {
            isHorizontal = true,
            isCurved = true
        } = opts || {};

        this.isHorizontal = isHorizontal;
        this.isCurved = isCurved;
    }

    protected override draw(): void {
        // 如果起点和终点重合，则不需要绘制
        if (this.arePointsCoincident()) {
            this.drawDirty = false;
            return;
        }

        const ctx = this.target.ctx;

        // 清除之前的绘制内容
        ctx.clearRect(0, 0, this.width, this.height);
        // 开始新的路径以避免之前的路径状态干扰
        ctx.beginPath();

        // 获取线段的边界框左上角坐标（当前线段的位置）（已考虑线宽）
        const { x: minX, y: minY } = this.calcPosition();
        // 计算绘制时的偏移量（半个线宽）
        const offset = this.lineWidth / 2;

        // 将线段起点和终点转换为相对于边界框左上角的坐标
        const startX = this.start.x - minX;
        const startY = this.start.y - minY;
        const endX = this.end.x - minX;
        const endY = this.end.y - minY;

        // 折线的中间点 (使用相对坐标计算)
        let midPoint1: Vector, midPoint2: Vector;

        if (this.isHorizontal) {
            midPoint1 = new Vector((startX + endX) / 2, startY);
            midPoint2 = new Vector((startX + endX) / 2, endY);
        } else {
            midPoint1 = new Vector(startX, (startY + endY) / 2);
            midPoint2 = new Vector(endX, (startY + endY) / 2);
        }

        // 设置线宽
        ctx.lineWidth = this.lineWidth;
        // 设置线段颜色
        ctx.strokeStyle = this.lineColor;
        // 设置线帽样式，确保端点完整
        ctx.lineCap = 'butt'; // "butt" | "round" | "square"
        // 设置线条连接点样式，使折角更平滑 (可选)
        // ctx.lineJoin = 'miter'; // "bevel" | "miter" | "round"

        ctx.moveTo(startX, startY);

        if (this.isCurved) {
            // 控制点也使用相对坐标
            ctx.bezierCurveTo(midPoint1.x, midPoint1.y, midPoint2.x, midPoint2.y, endX, endY);
        } else {
            ctx.lineTo(midPoint1.x, midPoint1.y);
            ctx.lineTo(midPoint2.x, midPoint2.y);
            ctx.lineTo(endX, endY);
        }

        // 描边
        ctx.stroke();

        // 标记为不需要重绘
        this.drawDirty = false;
    }
}